module.exports = "/img/banner-m.4b4d89be.png";